import { createStyle } from '@gluestack-style/react';

export const ActionsheetVirtualizedList = createStyle({
  w: '$full',
  h: 'auto',
});
